import React from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import { PATHWAY_LABELS, PATHWAY_COLORS } from './constants';

const useStyles = makeStyles(() => ({
  badge: {
    fontWeight: 600,
    fontSize: '0.72rem',
    height: 22,
    borderRadius: 11,
    color: '#fff',
  },
}));

const PathwayBadge = ({ pathway, size = 'small', className = '' }) => {
  const classes = useStyles();
  const label = PATHWAY_LABELS[pathway] || pathway;
  const bgColor = PATHWAY_COLORS[pathway] || '#757575';

  return (
    <Chip
      label={label}
      size={size}
      className={`${classes.badge} ${className}`}
      style={{ backgroundColor: bgColor }}
    />
  );
};

export default PathwayBadge;
